import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const projectTextSizeTokens = [
  "heading-1",
  "heading-1-sm",
  "heading-2",
  "heading-2-sm",
  "heading-3",
  "heading-3-sm",
  "heading-3-mobile",
  "body",
  "link",
  "factoid",
  "factoid-sm",
] as const;

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: [...projectTextSizeTokens] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const cleanHtmlRestProps = <T extends Record<string, unknown>>(
  props: T
) => {
  if ("node" in props) {
    delete props["node"];
  }
  return props;
};

/** Converts HTML snippets to plain text for search previews and cards. */
export function htmlToPlainText(html: string): string {
  const trimmed = html.trim();
  if (!trimmed) return "";

  let text = trimmed
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
    .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, "")
    .replace(/<[^>]+>/g, " ");

  text = text
    .replace(/&#x([0-9a-fA-F]+);/gi, (_, hex) =>
      String.fromCodePoint(parseInt(hex, 16))
    )
    .replace(/&#(\d+);/g, (_, code) =>
      String.fromCodePoint(parseInt(code, 10))
    )
    .replace(/&nbsp;/gi, " ")
    .replace(/&quot;/gi, '"')
    .replace(/&apos;/gi, "'")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&amp;/gi, "&");

  return text.replace(/\s+/g, " ").trim();
}

export const getImageSizeFromUrl = (
  url: string
): null | { height: string; width: string } => {
  const params = url.split("?").reverse()[0];
  if (!params) return null;
  const size = { height: "", width: "" };
  const parsedParams = params.split("&");
  const paramsObj = Object.fromEntries(
    parsedParams.map((param) => param.split("="))
  );
  if (!!paramsObj.height) {
    size.height = parseInt(paramsObj.height) + "px";
  }
  if (!!paramsObj.width) {
    size.width = parseInt(paramsObj.width) + "px";
  }
  return size;
};
